import { DefaultTheme } from 'styled-components';

// Definición de tipos para el tema
declare module 'styled-components' {
  export interface DefaultTheme {
    name: string;
    colors: {
      background: {
        primary: string;
        secondary: string;
        tertiary: string;
        overlay: string;
      };
      text: {
        primary: string;
        secondary: string;
        accent: string;
        disabled: string;
      };
      border: {
        primary: string;
        secondary: string;
      };
      button: {
        primary: {
          background: string;
          text: string;
          hover: string;
        };
        secondary: {
          background: string;
          text: string;
          hover: string;
        };
        danger: {
          background: string;
          text: string;
          hover: string;
        };
      };
      scrollbar: {
        track: string;
        thumb: string;
        thumbHover: string;
      };
      card: {
        background: string;
        hover: string;
        shadow: string;
      };
      input: {
        background: string;
        text: string;
        placeholder: string;
        border: string;
        focus: string;
      };
      divider: string;
    };
    borderRadius: {
      small: string;
      medium: string;
      large: string;
    };
    spacing: {
      xsmall: string;
      small: string;
      medium: string;
      large: string;
      xlarge: string;
    };
    shadows: {
      small: string;
      medium: string;
      large: string;
    };
    transitions: {
      fast: string;
      medium: string;
      slow: string;
    };
  }
}

// Tema oscuro
export const darkTheme: DefaultTheme = {
  name: 'dark',
  colors: {
    background: {
      primary: '#121212',
      secondary: '#1e1e1e',
      tertiary: '#2a2a2a',
      overlay: 'rgba(0, 0, 0, 0.75)',
    },
    text: {
      primary: '#ffffff',
      secondary: '#b3b3b3',
      accent: '#6e9eff',
      disabled: '#6c6c6c',
    },
    border: {
      primary: '#3a3a3a',
      secondary: '#4d4d4d',
    },
    button: {
      primary: {
        background: '#4a6baf',
        text: '#ffffff',
        hover: '#5a7bc0',
      },
      secondary: {
        background: '#2c2c2c',
        text: '#ffffff',
        hover: '#3a3a3a',
      },
      danger: {
        background: 'rgba(0, 0, 0, 0.85)',
        text: 'rgba(255, 255, 255, 0.9)',
        hover: 'rgba(0, 0, 0, 0.95)',
      },
    },
    scrollbar: {
      track: '#1a1a1a',
      thumb: '#4a4a4a',
      thumbHover: '#5a5a5a',
    },
    card: {
      background: '#2a2a2a',
      hover: '#323232',
      shadow: 'rgba(0, 0, 0, 0.5)',
    },
    input: {
      background: '#2c2c2c',
      text: '#ffffff',
      placeholder: '#8a8a8a',
      border: '#3a3a3a',
      focus: '#4a6baf',
    },
    divider: '#3a3a3a',
  },
  borderRadius: {
    small: '4px',
    medium: '8px',
    large: '12px',
  },
  spacing: {
    xsmall: '4px',
    small: '8px',
    medium: '16px',
    large: '24px',
    xlarge: '32px',
  },
  shadows: {
    small: '0 2px 4px rgba(0, 0, 0, 0.5)',
    medium: '0 4px 8px rgba(0, 0, 0, 0.5)',
    large: '0 8px 16px rgba(0, 0, 0, 0.5)',
  },
  transitions: {
    fast: '0.1s ease',
    medium: '0.2s ease',
    slow: '0.3s ease',
  },
};

// Tema claro (por si en el futuro se quiere implementar un toggle)
export const lightTheme: DefaultTheme = {
  name: 'light',
  colors: {
    background: {
      primary: '#f8f8f8',
      secondary: '#ffffff',
      tertiary: '#f0f0f0',
      overlay: 'rgba(0, 0, 0, 0.5)',
    },
    text: {
      primary: '#333333',
      secondary: '#666666',
      accent: '#4a6baf',
      disabled: '#999999',
    },
    border: {
      primary: '#e0e0e0',
      secondary: '#d0d0d0',
    },
    button: {
      primary: {
        background: '#4a6baf',
        text: '#ffffff',
        hover: '#5a7bc0',
      },
      secondary: {
        background: '#f0f0f0',
        text: '#333333',
        hover: '#e6e6e6',
      },
      danger: {
        background: 'rgba(0, 0, 0, 0.85)',
        text: 'rgba(255, 255, 255, 0.9)',
        hover: 'rgba(0, 0, 0, 0.95)',
      },
    },
    scrollbar: {
      track: '#f1f1f1',
      thumb: '#888888',
      thumbHover: '#555555',
    },
    card: {
      background: '#ffffff',
      hover: '#f9f9f9',
      shadow: 'rgba(0, 0, 0, 0.1)',
    },
    input: {
      background: '#ffffff',
      text: '#333333',
      placeholder: '#999999',
      border: '#e0e0e0',
      focus: '#4a6baf',
    },
    divider: '#e0e0e0',
  },
  borderRadius: {
    small: '4px',
    medium: '8px',
    large: '12px',
  },
  spacing: {
    xsmall: '4px',
    small: '8px',
    medium: '16px',
    large: '24px',
    xlarge: '32px',
  },
  shadows: {
    small: '0 2px 4px rgba(0, 0, 0, 0.05)',
    medium: '0 4px 8px rgba(0, 0, 0, 0.1)',
    large: '0 8px 16px rgba(0, 0, 0, 0.15)',
  },
  transitions: {
    fast: '0.1s ease',
    medium: '0.2s ease',
    slow: '0.3s ease',
  },
};

export default darkTheme;